import { PlacementErrorType } from '@frontend/sports/types/betslip';

import { ResultStatus } from '../../../../core/picks/pick-models';
import { BetslipError } from '../betslip-error';
import { NotifyUserErrorMixin } from '../notify-user-error';
import { ResultError } from '../result/result-error';
import { IPickPreCheckError, PreCheckErrorMixin } from './pre-check-error';

export class PickResultedPreCheckError extends PreCheckErrorMixin(NotifyUserErrorMixin<ResultError>(ResultError)) implements IPickPreCheckError {
    constructor(
        pickId: string,
        readonly resultStatus: ResultStatus,
    ) {
        super(pickId);
        this.type = PlacementErrorType.CutOffDateReached;
    }

    override pickId: string;

    override equals(error: BetslipError): boolean {
        return error instanceof PickResultedPreCheckError && error.pickId === this.pickId && error.resultStatus === this.resultStatus;
    }
}
